// extracted by mini-css-extract-plugin
module.exports = {"reportList":"ReportList_reportList__OqIv9","content":"ReportList_content__2EytS"};